/* eslint-disable react/jsx-max-depth */
import { useCallback, useState } from 'react';

import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import MuiTableRow from '@mui/material/TableRow';

import type { PrinterContextProvider_PdfPrint } from '../../../../contexts/PrinterContext';

import { DisabledFeatureInStrictMode } from '../../../DisabledFeatureInStrictMode';
import { RightDrawer } from '../../../RightDrawer';
import { PdfViewer } from '../../../PdfViewer';

import { TableRow } from './TableRow';

interface TableProps {
  readonly rows: readonly PrinterContextProvider_PdfPrint[];
}

export const Table = ({ rows }: Readonly<TableProps>) => {
  const [selectedPdfUrl, setSelectedPdfUrl] = useState<string | null>(null);

  const isOpenDrawer = Boolean(selectedPdfUrl);

  const handleDrawerClose = useCallback(() => {
    setSelectedPdfUrl(null);
  }, []);

  const handleDrawerOpen = useCallback((url: string) => {
    setSelectedPdfUrl(url);
  }, []);

  return (
    <>
      <RightDrawer
        isOpen={isOpenDrawer}
        onDrawerClose={handleDrawerClose}
        title="Visionneuse"
      >
        {!!selectedPdfUrl && (
          // FIXME: follow this example to implement pageRendering lock https://mozilla.github.io/pdf.js/examples/
          <DisabledFeatureInStrictMode>
            <PdfViewer showControls url={selectedPdfUrl} />
          </DisabledFeatureInStrictMode>
        )}
      </RightDrawer>
      <TableContainer>
        <MuiTable aria-label="Liste des impressions">
          <TableHead>
            <MuiTableRow>
              <TableCell align="left">Détails</TableCell>
              <TableCell align="right">Incrément</TableCell>
              <TableCell align="left">Date d&apos;impression</TableCell>
              <TableCell align="left">Auteur</TableCell>
              <TableCell align="center">Actions</TableCell>
            </MuiTableRow>
          </TableHead>
          <TableBody>
            {rows
              .filter((row) => !row.isTmp)
              .map((row) => (
                <TableRow
                  key={row.increment}
                  onDrawerOpen={handleDrawerOpen}
                  row={row}
                />
              ))}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </>
  );
};
